import {Injectable} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {ListClaimsResponse} from "../../../../auto-generated-server-dtos/adjuster/list-claims/list-claims-response";

@Injectable({
    providedIn: 'root'
})
export class ListClaimsService {

    constructor(private httpClient: HttpClient) {
    }

    listClaims(ajaxSettings: DataTables.AjaxSettings, showSelfAssignedClaimsOnly: boolean, statusFilter: string[]) {
        return this.httpClient.post<ListClaimsResponse>(`${environment.apiServer}/Adjuster/ListClaims`, {showSelfAssignedClaimsOnly, ajaxSettings, statusFilter});
    }
}
